export class SourceSubscriptionData {
    source: string;
    subName: string;
}


// WEBPACK FOOTER //
// ./src/app/modules/validate-loss-data-submission/shared/entities/sourceSubscirptionData.ts